module.exports = __webpack_public_path__ + "static/media/no3.2c045d80.webp";